export const roleDescriptions: Record<string, string> = {
  "Full Access": "Complete control over account settings, billing, and user permissions.",
  "Can Pay Bills": "Can manage payments, buy energy units, and view full account details.",
  "Viewer": "Read-only access to view consumption data and account details."
}

export const corporateRoleNames: Record<string, string> = {
  "Full Access": "Administrator",
  "Can Pay Bills": "Finance",
  "Viewer": "Operations"
}

export const corporateRoleDescriptions: Record<string, string> = {
  "Full Access": "Complete control over account settings, billing, and user permissions.",
  "Can Pay Bills": "Can manage payments, buy energy units, and view full account details.",
  "Viewer": "Read-only access to view consumption data and account details."
}